/**
 * 便の呼び方。**行先は終点ではない。**
 *
 * にしてつの行先は方面表示で、**ループ便では大きく食い違う。**
 *
 *     21B  行先「雁の巣・和白」            終点 天神三丁目   28 便
 *     21A  行先「雁の巣レクリエーション…」 終点 天神三丁目   26 便
 *     22T  行先「天神」                    終点 香椎浜車庫    3 便
 *     1-2  行先「みなと香椎・こども病院」  終点 ベジフル…     3 便
 *
 * 折り返したあとも「雁の巣・和白行き」に見えるので、**どこへ帰るのかが
 * 読めない。**行先はにしてつの呼び方のまま残して、終点を添える。
 */

/**
 * 行先が**終点を名指していない**か。終点を添えるかどうかの判定。
 *
 * ループ便だけではない。「博多駅」行きは駅前の停留所ではなく**博多バス
 * ターミナルの中**で終わる（29・30 便）ので、そちらも添える。
 *
 * **言い換えただけのものには添えない。**行先「千早駅前」／終点「千早駅」、
 * 行先「大蔵・高美台」／終点「大蔵」を並べても読む人の役に立たない。
 * **片方がもう片方を含むかどうか**で切り分ける — 別の場所なら含まない。
 *
 * @param {{destination?: string, terminal_name?: string}} bus
 * @returns {boolean}
 */
export function viaOnly(bus) {
  const via = bus?.destination || "";
  const end = bus?.terminal_name || "";
  if (! via || ! end) return false;

  // 「（１５：西向き）」のような乗り場の断りは比べない。
  // 「天神三丁目」と「天神三丁目（１５：西向き）」は同じ場所
  const bare = (x) => x.replace(/[(（].*$/, "").trim();

  return ! bare(end).includes(bare(via)) && ! bare(via).includes(bare(end));
}
